import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { JamesAdminComponent } from './james-admin.component';

const routes: Routes = [
  { path: '', component: JamesAdminComponent }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class JamesAdminRouting {}